import { Model } from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class ArticleHasChild extends Model{
  static entity = 'articleHasChilds'
  static fields () {
    return {
      id: this.attr(null),
      articles_id: this.attr(null),
      child_id: this.attr(null),
      quantity_min: this.attr(null),
      quantity_max: this.attr(null),
      quantity_default: this.attr(null),
      quantity_editable: this.attr(null),
      quantity_no: this.attr(null),
      quantity_no_device: this.attr(null),
      quantity_multiplier: this.attr(null),

      article: this.belongsTo(Article, 'child_id')
    }
  }
}
  